import { Button, Card, Stack, Text } from '@mantine/core';
import { IconCircleCheck } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

export function DoneSection(): JSX.Element {
  const navigate = useNavigate();

  return (
    <Card
      shadow="sm"
      padding="lg"
      radius="md"
      withBorder
      style={{ backgroundColor: 'var(--unify-bg-paper)', borderColor: 'var(--mantine-color-gray-5)' }}
    >
      <Stack gap="lg" align="center" py="xl">
        <IconCircleCheck size={64} style={{ color: 'var(--mantine-color-green-6)' }} />
        <Text size="xl" fw={600}>
          You&apos;re all set!
        </Text>
        <Text size="sm" c="dimmed" ta="center" maw={400}>
          Your profile is complete. You&apos;ll receive your domain email and next steps shortly. You can log in with
          your new credentials when ready.
        </Text>
        <Button size="md" onClick={() => navigate('/dashboard')}>
          Go to Dashboard
        </Button>
      </Stack>
    </Card>
  );
}
